<template>
  <v-container>
    <v-row v-for="(item, index) in selection" :key="index">
      <v-select style="max-width: 45%;" outlined :items="spaces" item-text="name" item-value="id" v-model="item.space" :returnObject="true" />
      <v-select
        style="max-width: 45%;"
        :disabled="!item.space"
        outlined
        :items="targetEnvs(item.space)"
        item-text="name"
        item-value="id"
        v-model="item.environment"
        :returnObject="true"
      />
      <v-icon style="max-width: 10%;" @click="selection.splice(index, 1)" v-show="index < selection.length - 1">
        mdi-delete
      </v-icon>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      selection: [{ space: null, environment: null }],
    };
  },
  props: ["spaces", "multiple"],
  emits: ["changedSelection"],
  components: {},
  computed: {},
  watch: {
    selection: {
      handler(newArray, oldArray) {
        if (this.multiple && this.selection.every((i) => i.space && i.environment)) {
          this.selection.push({ space: null, environment: null });
        }
        this.$emit(
          "changedSelection",
          this.selection.filter((i) => i.space && i.environment)
        );
      },
      deep: true, // Watch for deep changes
    },
  },
  methods: {
    targetEnvs(targetSpace) {
      if (!targetSpace) return [];
      let space = this.spaces.find((s) => targetSpace.id == s.id);
      if (space && space.environments) return space.environments;
      return [];
    },
  },
};
</script>

<style lang="scss" scoped></style>
